import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, uaeProjectsBaseURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { VALIDATE_FLIGHT_DETAILS, VALIDATE_FLIGHT_DETAILS_ERROR, VALIDATE_FLIGHT_DETAILS_SUCCESS } from '../../actions';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getValidateFlightDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/v1/flight-validation`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: VALIDATE_FLIGHT_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: VALIDATE_FLIGHT_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VALIDATE_FLIGHT_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetValidateFlightDetails() {
  yield takeEvery(VALIDATE_FLIGHT_DETAILS, getValidateFlightDetails);
}

function* getValidateFlightDetailsSaga() {
  yield all([fork(watchGetValidateFlightDetails)]);
}

export default getValidateFlightDetailsSaga;
